import { useLocation, useParams } from "react-router-dom";
import {isValidUniqueName} from "app/shared-components/channel/utils/uniqueNameFunctions";

export default function useLocationStatus() {
  const routeParams = useParams();
  const location = useLocation();
  const { groupId, channelId, topicId, clientId, fileId, callId} = routeParams;
  const isUniqueName= isValidUniqueName(groupId);
  const isTopics = location.pathname.endsWith('topics');
  const isAdmin = location.pathname.endsWith('admin');
  const isFiles = location.pathname.includes('/files');
  const isMembers = location.pathname.includes('/members');
  const isClients = location.pathname.includes('/clients');
  const isChannel = Boolean(channelId);
  const isClient = Boolean(clientId);
  const isFile = Boolean(fileId);
  const isVideoCall = Boolean(callId);
  const isTopic = location.pathname.includes('/topic/');
  const isMember = location.pathname.includes('/member/');
  const isResult = location.pathname.includes('/result/');
  const isHome = location.pathname.endsWith(groupId) || location.pathname.endsWith(groupId + '/searchresults');
  const isSearchResults = location.pathname.endsWith('/searchresults');

  return {isTopics, isAdmin, isFiles, isMembers, isClients, isChannel, isVideoCall, isUniqueName,
          isClient, isHome, isFile, isTopic, isMember, isResult, isSearchResults};
};